export const formatCurrency = (value) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 2,
  }).format(Number(value || 0));

export const formatCompactCurrency = (value) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(Number(value || 0));

export const formatNumber = (value, options = {}) =>
  new Intl.NumberFormat("pt-BR", options).format(Number(value || 0));

export const formatDays = (value) => `${formatNumber(value, { maximumFractionDigits: 0 })} dias`;

export const formatAverageDays = (value) =>
  `${formatNumber(value, { minimumFractionDigits: 1, maximumFractionDigits: 1 })} dias`;

export const formatDateTime = (value) => {
  if (!value) return "-";

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "-";

  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(parsed);
};
